module.exports = __webpack_public_path__ + "img/priest_m.2ef4edec.png";